import type ExtensionInstance from '../../instance';
import ExtensionCapability from '../../capability';
import { BasicObservable, type Specs } from '@doxyme/extensions-common';

type Control = Specs.Control.Control;

export default class ControlCapability<
  Constraints extends Specs.Control.Constraints,
> extends ExtensionCapability<Constraints> {
  readonly controls = new BasicObservable<Control[]>([]);

  /**
   * @hidden
   */
  override addInstance(instance: ExtensionInstance): void {
    super.addInstance(instance);
    // Only one control per extension is supported, we take first one.
    const config = this.configsBy(instance)[0];
    if (config) {
      this.controls.value = [
        ...this.controls.value,
        {
          id: config['id'] as string, // cast is needed because launcher config doesn't specify 'id' since it is added at runtime
          instanceId: instance.id,
          icon: config.icon,
          label: config.label,
          onClick: () => this.handleMessages(instance, config.messages),
        },
      ];
    }
  }

  /**
   * @hidden
   */
  override removeInstance(instance: ExtensionInstance): void {
    this.controls.value = this.controls.value.filter(
      (f) => f.instanceId !== instance.id,
    );

    super.removeInstance(instance);
  }

  /**
   * @hidden
   */
  override clear(): void {
    super.clear();
    this.controls.value = [];
  }
}
